import { createActionRecordAction } from "../../actionCreator";
export const updateNetsLabel = createActionRecordAction("updateNetsLabel", (netLabelMap, canUndo = true) => {
    return {
        payload: {
            netLabelMap,
            canUndo: canUndo,
            updatesDocumentTimestamp: true,
            shouldGenerateActionRecord: true,
            hasInheritedRules: true,
            hasInheritedCalculations: true,
            requiresDescendantRebake: true,
        },
    };
}, "updated the label of a net");
export const disconnectPinsByDescriptorAction = createActionRecordAction("disconnectPinsByDescriptor", (pinDescriptors) => {
    return {
        payload: {
            pinDescriptors,
            canUndo: true,
            updatesDocumentTimestamp: true,
            shouldGenerateActionRecord: true,
        },
    };
}, "disconnected pins");
export const connectNetsByDescriptorAction = createActionRecordAction("connectNetsByDescriptor", (netConnections, portalPart, groundPart, userUid) => {
    return {
        payload: {
            netConnections,
            portalPart,
            groundPart,
            userUid,
            canUndo: true,
            updatesDocumentTimestamp: true,
            shouldGenerateActionRecord: true,
        },
    };
}, "connected nets");
//# sourceMappingURL=actions.js.map